import React, { ReactElement } from 'react';

import NoSSR from '../../../context/ssr/no-ssr';
import { makeClassNames } from '../../../utils/styles';
import { IIcon } from '../../atoms/icons/icon';
import IconArrowLeft from '../../atoms/icons/icon-arrow-left';
import IconArrowRight from '../../atoms/icons/icon-arrow-right';
import { IMenuGliderItems, MenuGliderItems } from '../../organisms';
import GliderWrapper from '../../organisms/glider-wrapper/glider-wrapper';

export interface IMenuGlider {
  items?: IMenuGliderItems['items'];
  activeSlideIndex?: number;
  onItemSelectedCallback?: (id: number) => void;
}

const classNames = () =>
  makeClassNames({
    gliderWrapper: 'menu-glider--wrapper',
  });

const ssrPlaceholder = (props: IMenuGliderItems, cn: ReturnType<typeof classNames>) => {
  return (
    <div className={cn.gliderWrapper}>
      <MenuGliderItems {...props} isSSR />
    </div>
  );
};

const iconLeft = (): ReactElement<IIcon> => <IconArrowLeft size="xxxsmall" color="blue" />;
const iconRight = (): ReactElement<IIcon> => <IconArrowRight size="xxxsmall" color="blue" />;

const MenuGlider = ({ items, activeSlideIndex, onItemSelectedCallback }: IMenuGlider) => {
  const cn = classNames();
  const gliderComponentProps: IMenuGliderItems = {
    items,
    activeSlideIndex,
    variant: 'mgv',
    onItemSelectedCallback,
  };

  return (
    <NoSSR placeholder={ssrPlaceholder(gliderComponentProps, cn)}>
      <GliderWrapper
        Component={MenuGliderItems}
        bordered="top-bottom"
        duration={2}
        exactWidth
        hasArrows
        iconLeft={iconLeft()}
        iconRight={iconRight()}
        itemWidth={66}
        propsComponent={gliderComponentProps}
        scrollLock
        topOffset
      />
    </NoSSR>
  );
};

export default MenuGlider;
